import React, { useEffect, useState } from "react";
import {
  Image,
  Text,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  DrawerHeader,
  DrawerCloseButton,
  Flex,
  Box,
} from "@chakra-ui/react";

export const GuideDisplay = ({ guide, onClose, isOpen }) => {
  const [renderedDescription, setRenderedDescription] = useState("");

  useEffect(() => {
    if (isOpen) {
      const descriptionHTML = parseDescriptionWithLinksAndEmbeds(
        guide.description
      );
      setRenderedDescription(descriptionHTML);
    }
  }, [isOpen, guide.description]);

  const parseDescriptionWithLinksAndEmbeds = (text) => {
    const urlRegex =
      /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
    return text.replace(urlRegex, (url) => {
      // Enhanced regex to include youtu.be links
      const youtubeRegex =
        /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/;
      const match = url.match(youtubeRegex);
      if (match) {
        const videoId = match[4]; // Extracts video ID from both youtube.com and youtu.be links
        return `<iframe width="100%" style="max-width: calc(100%); padding-top: 10px; padding-bottom: 10px;" height="315" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
      }

      // Return normal link if not a YouTube URL
      return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color: #ffb6b6;">${url}</a>`;
    });
  };

  return (
    <Drawer placement={"bottom"} onClose={onClose} isOpen={isOpen}>
      <DrawerOverlay />
      <DrawerContent maxH={"84vh"}>
        <Flex
          mx={3}
          my={4}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Text mr={4} fontSize={"18px"} fontWeight={800}>
            {guide.title}
          </Text>

          <DrawerCloseButton pos={"relative"} top={0} right={0} />
        </Flex>
        <DrawerBody px={0} pt={0} pb={12}>
          <Image
            pb={4}
            objectFit="cover"
            //   h={"95px"}
            //   w={"120px"}
            src={guide.images}
            alt={guide.title}
          />
          {/* <Text  px={4}>{guide.description}</Text> */}
          {guide.description && (
            <Text
              px={4}
              dangerouslySetInnerHTML={{
                __html: renderedDescription,
              }}
            />
          )}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
